<template>
    <div v-if="value">
        <div v-if="orderedDaysAgo">
            Last ordered
            {{ orderedDaysAgo | numberFormat }}
            {{ orderedDaysAgo === 1 ? 'day' : 'days' }}
            ago
        </div>
        <div v-if="value.previous_order_count || value.pending_order_count">
            <div class="btn btn-xs btn-default" @click="showDialog = true">
                <div v-if="value.previous_order_count">
                    Previous Orders: {{ value.previous_order_count | numberFormat }}
                </div>
                <div v-if="value.pending_order_count">
                    Pending Orders: {{ value.pending_order_count | numberFormat }}
                </div>
            </div>
        </div>
        <VendorInventoryItemDialog v-if="showDialog" :id="value.id" @hide="showDialog = false" />
    </div>
</template>

<script>
export default {
    components: {
        VendorInventoryItemDialog: require('@/pages/vendors/VendorInventoryItemDialog.vue').default,
    },
    props: ['value'],
    data() {
        return {
            showDialog: false,
        };
    },
    computed: {
        orderedDaysAgo() {
            if (this.value && this.value.last_ordered_at) {
                let diff = new Date - new Date(this.value.last_ordered_at);
                return Math.floor(diff / (1000 * 60 * 60 * 24));
            }
        },
    },
};
</script>
